import { cloneElement, useMemo } from 'react';
import "../../styles/base.scss";
interface Props {
    /**
     * The response state that changes the border style to success or failure
     * true: success green style - false: red failure style - undefined not styled at all
     */
    responseState: boolean | undefined;
    /**
     * An optional display messages to display below the component with a description
     */
    message?: string;
    /**
     * The children component
     */
    children: JSX.Element;
}

/**
 * component that clones a component and style it according to an endpoint response
 */
export const FeedbackBorderContainer = ({ responseState, message, children }: Props) => {
    /**
     * Calculates the style needed for the border 
     * [responseState] listen to the response state to determine the style
     */
    const feedbackStyle = useMemo(() => {
        switch(responseState) {
            case true : return { border: "input-success", text: "#82B366", message };
            case false : return { border: "input-error", text: "#B85450",  message };
            default : return { border: "", text: "" }; 
        }
    },[responseState]);

    /**
     * Clones and styles the children component
     */
    const styledChildren = cloneElement(children, {
        className: `${children.props.className || ''} ${feedbackStyle.border}`.trim()
    });

    return (
        <div>
            {styledChildren}
            {responseState !== undefined &&(
                <span style={{ color: feedbackStyle.text }}>
                    {feedbackStyle.message ?? ""}
                </span>
            )}
        </div>
    );
};
